import { RPopup, gradientMarkerPopupOffset } from "maplibre-react-components";
import { PlatformIndicator } from "../../components/PlatformIndicator";
import { Button } from "primereact/button";
import { RouteName } from "../../components/RouteName";

export function PopupStopMl({GStop,onClose}) {

    const routes = (typeof GStop.stats.routes !== 'undefined') ? Object.entries(GStop.stats.routes).map(([, GRoute]) => {
        return (<RouteName GRoute={GRoute} key={GRoute.route_id}></RouteName>);
    }) :  [];

    return (
        <RPopup
            longitude={GStop.stop_lon}
            latitude={GStop.stop_lat}
            offset={gradientMarkerPopupOffset}
            /* onMapClick={onClose} */
            style={{
                width: '350px'
            }}
        >
            <Button rounded text
                icon="pi pi-times" 
                size="small"  
                severity="danger" 
                aria-label="Cancel" 
                className='absolute top-0 right-0' 
                onClick={onClose} 
            />

            <h3>🚏 <span style={{ fontWeight: 'normal' }} className='text-200 text-xs'>
                {GStop.stop_id}</span> {GStop.stop_name} 
                <PlatformIndicator platformCode={GStop.platform_code} />
            </h3>
            {
                (routes.length > 0)
                    ? <div className="p-0 m-0" style={{fontSize: '1rem'}}>{routes}</div>
                    : '❌ Brak linii odjeżdżających z tego stanowiska.'
            }
        </RPopup>
    )    

}